import { useContext } from "react";
import { HomeContext } from "../../contexts/homeContext";

const useHomeContext = () => {
  const value = useContext(HomeContext);
  return value;
};

export default useHomeContext;
